import type { ApiErrorCode } from '@shared/types/apiErrorCodes.generated';

type UpstreamErrorCode = 'FILE_STORAGE_UNAVAILABLE' | 'PAYMENT_PROVIDER_UNAVAILABLE' | 'AUTH_PROVIDER_UNAVAILABLE';

export const ERROR_CODE_MESSAGES: Record<ApiErrorCode | UpstreamErrorCode, string> = {
  USER_NOT_CONNECTED: "Votre session a expiré. Reconnectez-vous pour continuer.",
  FORBIDDEN_OPERATION: "Vous n'avez pas le droit d'effectuer cette action.",

  CANNOT_UPDATE_NON_TODO_TASK: "Seule une tâche à faire peut être modifiée.",
  INVALID_TASK_STATUS_TRANSITION: "Cette tâche ne peut pas passer dans cet état.",
  TASK_NOT_FOUND: "Cette tâche n'existe plus.",
  TASK_TITLE_TOO_LONG: "Le titre de la tâche est trop long.",
  TASK_TITLE_TOO_SHORT: "Le titre de la tâche est trop court.",
  USER_IS_NOT_TASK_OWNER: "Cette tâche ne vous appartient pas.",

  CATEGORY_NOT_FOUND: "Cette catégorie n'existe plus.",
  RESOURCE_CATEGORY_NOT_FOUND: "Cette catégorie n'existe plus.",
  RESOURCE_CATEGORY_COLOR_EMPTY: "Choisissez une couleur pour la catégorie.",
  RESOURCE_CATEGORY_COLOR_INVALID_FORMAT: "La couleur de la catégorie n'est pas valide.",
  RESOURCE_CATEGORY_IN_USE: "Cette catégorie est utilisée par des ressources et ne peut pas être supprimée.",
  RESOURCE_CATEGORY_NAME_ALREADY_EXISTS: "Une catégorie porte déjà ce nom.",
  RESOURCE_CATEGORY_NAME_EMPTY: "Donnez un nom à la catégorie.",
  RESOURCE_CATEGORY_NAME_TOO_LONG: "Le nom de la catégorie est trop long.",
  USER_IS_NOT_RESOURCE_CATEGORY_OWNER: "Cette catégorie ne vous appartient pas.",

  RESOURCE_NOT_FOUND: "Cette ressource n'existe plus.",
  RESOURCE_NOT_FOUND_FOR_DELETE: "Cette ressource a déjà été supprimée.",
  RESOURCE_IN_USE: "Cette ressource est partagée avec une classe et ne peut pas être supprimée.",
  RESOURCE_DOES_NOT_BELONG_TO_SUBJECT: "Cette ressource n'appartient pas à cette matière.",
  INVALID_RESOURCE_NAME: "Le nom de la ressource n'est pas valide.",
  USER_IS_NOT_RESOURCE_OWNER: "Cette ressource ne vous appartient pas.",
  FILE_ALREADY_ATTACHED: "Ce fichier est déjà rattaché à une ressource.",
  FILE_TOO_LARGE: "Ce fichier est trop volumineux. La taille maximale autorisée est 15 Mo.",
  UNSUPPORTED_FILE_TYPE: "Ce type de fichier n'est pas pris en charge.",
  QUOTA_EXCEEDED: "Vous avez atteint votre limite de stockage. Veuillez supprimer des fichiers ou passer à un abonnement supérieur.",
  TOO_MANY_RESOURCES: "Vous avez atteint le nombre maximal de ressources.",

  SUBJECT_NOT_FOUND: "Cette matière n'existe plus.",
  SUBJECT_NAME_ALREADY_EXISTS: "Une matière porte déjà ce nom.",
  SUBJECT_NAME_TOO_LONG: "Le nom de la matière est trop long.",
  SUBJECT_LEVEL_NOT_FOUND: "Le niveau de cette matière n'existe plus.",
  USER_IS_NOT_SUBJECT_OWNER: "Cette matière ne vous appartient pas.",

  LEVEL_NOT_FOUND: "Ce niveau n'existe plus.",
  LEVEL_IN_USE: "Ce niveau est utilisé par des matières ou des classes et ne peut pas être supprimé.",
  LEVEL_NAME_ALREADY_EXISTS: "Un niveau porte déjà ce nom.",
  LEVEL_NAME_EMPTY: "Donnez un nom au niveau.",
  LEVEL_NAME_TOO_LONG: "Le nom du niveau est trop long.",

  CLASS_LEVEL_NOT_FOUND: "Le niveau de cette classe n'existe plus.",
  CLASS_NAME_ALREADY_EXISTS: "Une classe porte déjà ce nom.",
  CLASS_SPACE_ALREADY_EXISTS: "Cette classe existe déjà.",
  CLASS_SPACE_ALREADY_ARCHIVED: "Cette classe est déjà archivée.",
  CLASS_SPACE_IS_ARCHIVED: "Cette classe est archivée.",
  CLASS_SPACE_NOT_ARCHIVED: "Cette classe n'est pas archivée.",
  CLASS_SPACE_NOT_FOUND: "Cette classe n'existe plus.",
  CLASS_SUBJECT_NOT_FOUND: "Cette matière n'est pas ouverte pour cette classe.",
  CLASS_MUST_HAVE_AT_LEAST_ONE_SUBJECT: "Une classe doit garder au moins une matière.",
  INVALID_CLASS_NAME: "Le nom de la classe n'est pas valide.",
  INVALID_CLASS_SPACE_COLOR: "La couleur de la classe n'est pas valide.",
  INVALID_ACADEMIC_YEAR: "L'année scolaire n'est pas valide.",
  NOT_CLASS_SPACE_OWNER: "Cette classe ne vous appartient pas.",
  NOT_CLASS_SUBJECT_OWNER: "Cette matière de classe ne vous appartient pas.",
  SUBJECT_ALREADY_OPEN_FOR_CLASS: "Cette matière est déjà ouverte pour cette classe.",
  NO_RESOURCES_TO_SHARE: "Aucune ressource à partager.",
  RESOURCE_ALREADY_SHARED_WITH_CLASS: "Cette ressource est déjà partagée avec cette classe.",
  RESOURCE_NOT_IN_CLASS_SUBJECT: "Cette ressource n'est pas partagée dans cette matière.",

  FILE_STORAGE_UNAVAILABLE: "Le stockage de fichiers est momentanément indisponible. Réessayez dans quelques instants.",
  PAYMENT_PROVIDER_UNAVAILABLE: "Le paiement est momentanément indisponible. Réessayez dans quelques instants.",
  AUTH_PROVIDER_UNAVAILABLE: "La connexion est momentanément indisponible. Réessayez dans quelques instants.",
};
